import ChallengeEdit from './ChallengeEdit';

export default ChallengeEdit;
